export default __webpack_public_path__ + "static/1-5-2-0-6c8d33154fe0540d0bfef28f686b1165.jpg";